import { render, staticRenderFns } from "./tariff-history-detail-popup.vue?vue&type=template&id=47803fd8&scoped=true&"
import script from "./tariff-history-detail-popup.vue?vue&type=script&lang=ts&"
export * from "./tariff-history-detail-popup.vue?vue&type=script&lang=ts&"
import style0 from "./tariff-history-detail-popup.vue?vue&type=style&index=0&id=47803fd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47803fd8",
  null
  
)

export default component.exports